import { useDispatch, useSelector } from 'react-redux';
import { 
  createSortingModel, 
  setSortingModelWeightages, 
  setSortingModelVisibility,
  resetSortingModel,
  clearHospitalDataCache,
  getCacheInfo
} from '../Redux/sortingModel/sortingModel.actions';

export const useSortingModel = () => {
  const dispatch = useDispatch();
  const sortingModelState = useSelector((state) => state.sortingModel);

  const {
    isLoading,
    error,
    isSuccess,
    weightages,
    rankings,
    totalHospitalsRanked,
    sampleRankings,
    isVisible
  } = sortingModelState;

  const createModel = async (weightages) => {
    return await dispatch(createSortingModel(weightages));
  };

  const updateWeightages = (newWeightages) => {
    dispatch(setSortingModelWeightages(newWeightages));
  };

  const showSortingModel = () => {
    dispatch(setSortingModelVisibility(true));
  };

  const hideSortingModel = () => {
    dispatch(setSortingModelVisibility(false));
  };

  const resetModel = () => {
    dispatch(resetSortingModel());
  };

  const clearCache = async () => {
    return await dispatch(clearHospitalDataCache());
  };

  const getCacheInformation = async () => {
    return await dispatch(getCacheInfo());
  };

  const getDefaultWeightages = () => ({
    beds: 5,
    discharges: 5,
    revenue: 5,
    rating: 5
  });

  const validateWeightages = (weightages) => {
    const required = ['beds', 'discharges', 'revenue', 'rating'];
    const missing = required.filter(field => !(field in weightages));
    
    if (missing.length > 0) {
      return {
        isValid: false,
        error: `Missing required fields: ${missing.join(', ')}`
      };
    }

    const invalidValues = Object.entries(weightages).filter(([key, value]) => {
      const num = Number(value);
      return isNaN(num) || num < 0 || num > 10;
    });

    if (invalidValues.length > 0) {
      return {
        isValid: false,
        error: `Invalid weight values. All weights must be between 0 and 10.`
      };
    }

    return { isValid: true };
  };

  return {
    // State
    isLoading,
    error,
    isSuccess,
    weightages,
    rankings,
    totalHospitalsRanked,
    sampleRankings,
    isVisible,

    // Actions
    createModel,
    updateWeightages,
    showSortingModel,
    hideSortingModel,
    resetModel,
    clearCache,
    getCacheInformation,

    // Utilities
    getDefaultWeightages,
    validateWeightages
  };
};
